"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var rangeHelper_1 = __importDefault(require("./rangeHelper"));
var common_1 = require("@scuf/common");
var genDefaultZoomButtons_1 = __importDefault(require("../../../utils/genDefaultZoomButtons"));
var Head = /** @class */ (function (_super) {
    __extends(Head, _super);
    function Head() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.genClasses = function (base, props) {
            var className = props.className, align = props.align;
            var classes = base;
            if (align) {
                classes += " align-" + align;
            }
            if (className) {
                classes += " " + className;
            }
            return classes;
        };
        _this.setNavRange = function (range) {
            var from = range.from, to = range.to;
            var min = Number(from);
            var max = Number(to);
            _this.props.chart.xAxis[0].setExtremes(min, max);
        };
        _this.handleRangeSelect = function (range) {
            var updateGroupRange = _this.props.updateGroupRange;
            var grouping = {
                type: '',
                count: 0,
                active: ''
            };
            if (range.from && range.to) {
                _this.setNavRange(range);
                updateGroupRange(grouping, range);
            }
        };
        _this.handleGroupingSelect = function (type, count, text) {
            var _a = _this.props, chart = _a.chart, updateGroupRange = _a.updateGroupRange;
            var _b = chart.xAxis[0].getExtremes(), dataMax = _b.dataMax, dataMin = _b.dataMin, min = _b.min;
            var range;
            var rangeMin;
            var rangeMax;
            switch (type) {
                case 'ytd':
                    range = rangeHelper_1.default('year', 1);
                    rangeMin = dataMax - range;
                    rangeMax = dataMax;
                    break;
                case 'all':
                    rangeMin = dataMin;
                    rangeMax = dataMax;
                    break;
                default:
                    range = rangeHelper_1.default(type, count);
                    rangeMin = min;
                    rangeMax = rangeMin + range;
                    break;
            }
            var newRange = {
                from: new Date(rangeMin),
                to: new Date(rangeMax)
            };
            var grouping = { type: type, count: count, active: text };
            _this.setNavRange(newRange);
            updateGroupRange(grouping, newRange);
        };
        _this.genButtons = function () {
            var _a = _this.props, grouping = _a.grouping, chart = _a.chart;
            var rangeSelector = _this.props.rangeSelector;
            var buttons = [];
            if (rangeSelector.buttons) {
                buttons = rangeSelector.buttons;
            }
            else {
                var _b = chart.xAxis[0].getExtremes(), dataMax = _b.dataMax, dataMin = _b.dataMin;
                if (dataMax !== null && dataMin !== null) {
                    buttons = genDefaultZoomButtons_1.default(dataMax, dataMin);
                }
            }
            buttons = buttons.map(function (button, index) {
                var text = button.text, type = button.type, count = button.count;
                var buttonType = grouping.active === text ? 'primary' : 'secondary';
                return (React.createElement(common_1.Button, { key: index, type: buttonType, content: text, onClick: _this.handleGroupingSelect.bind(_this, type, count, text), size: "small" }));
            });
            return buttons;
        };
        return _this;
    }
    Head.prototype.render = function () {
        var _a = this.props, title = _a.title, subtitle = _a.subtitle, currentRange = _a.currentRange, rangeSelector = _a.rangeSelector;
        var _b = rangeSelector || { enabled: false, showDatePicker: false, showButtons: false }, showControls = _b.enabled, showDatePicker = _b.showDatePicker, showButtons = _b.showButtons;
        return (React.createElement("div", { className: "forge ui chart-head" },
            title && React.createElement("div", { className: this.genClasses('title', title) }, title.text),
            subtitle && React.createElement("div", { className: this.genClasses('subtitle', subtitle) }, subtitle.text),
            showControls && (React.createElement("div", { className: "controls" },
                React.createElement(common_1.Button.Group, { className: "zoom-button-group" }, showButtons && this.genButtons()),
                React.createElement("div", { className: "range-selector" }, showDatePicker && (React.createElement(common_1.DatePicker, { type: "daterange", rangeValue: currentRange, reserveSpace: false, closeOnSelection: true, onRangeSelect: this.handleRangeSelect })))))));
    };
    return Head;
}(React.Component));
exports.default = Head;
//# sourceMappingURL=Head.js.map